import { useLocation, useParams } from 'react-router-dom'
import { useGateValue } from '@statsig/react-bindings'

import { FeatureFlagValue } from '@types'
import {
  URL_MERCHANT,
  URL_NO_COMPANY,
  URL_ONBOARDING,
  URL_SALESPERSON,
  URL_SITE_TINO,
  URL_SUPPLIER,
} from 'constants/urls'
import { useRouter } from 'modules/navigation'
import { useSituation, useUser } from 'modules/user'

export function useRedirect() {
  const { companyId } = useParams<{ companyId: string }>()
  const { user } = useUser()
  const router = useRouter()
  const { pathname } = useLocation()
  const {
    redirectTo: situationRedirectTo,
    isPowerOfAttorneyPending,
    isMissingPowerOfAttorneyDocuments,
  } = useSituation()
  const isNewXpEnabledForSalesPerson = useGateValue(
    FeatureFlagValue.NEW_EXPERIENCE_SALESPERSON
  )

  function pushRouter(root: string, redirectPath: string) {
    if (!pathname.startsWith(root) || !companyId) {
      router.push(redirectPath)
    }
  }

  function redirectToCompanyType() {
    const currentCompanyId = user.data.currentCompany.id || companyId

    let root = URL_MERCHANT

    if (user.data.currentCompany.is_salesperson) {
      root = isNewXpEnabledForSalesPerson ? URL_SUPPLIER : URL_SALESPERSON
    } else if (user.data.currentCompany.is_seller) {
      root = URL_SUPPLIER
    }

    const redirectPath = `${root}/${currentCompanyId}`
    pushRouter(root, redirectPath)
  }

  function redirectTo() {
    situationRedirectTo(() => {
      const isNotOwner =
        isPowerOfAttorneyPending || isMissingPowerOfAttorneyDocuments

      if (isNotOwner && !user.data.currentCompany.is_seller) {
        return redirectToTinoSite()
      }

      if (user.data.currentCompany.id) {
        return redirectToCompanyType()
      }

      return router.push(`${URL_ONBOARDING}${URL_NO_COMPANY}`)
    })
  }

  function redirectToTinoSite() {
    window.location.replace(URL_SITE_TINO)
  }

  return {
    redirectTo,
    redirectToTinoSite,
  }
}
